import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Drawer, Table, Button, Input, Form, Row, Col, Select } from 'antd';
import {
    QuestionCircleOutlined,
    LeftOutlined
} from "@ant-design/icons";
import { getColumns } from './combineColumns';
import DrawerNew from './combineNew/drawer';
import VariationDetails from '../VariationDetails';
import apiService from '../../VariantProductsTable/data'
// import globalData from '../../../config/global_data';
import VariantDrawer from '../VariantDrawer';
import { triggerNotification } from '../../common/notify';
const { Option } = Select;

const CombineDrawer = ({ open, onClose, customfielddata = {}, selectedData, reload, setisloader, globalList ,setGlobalList }) => {
    const [form] = Form.useForm();

    const [selectedField, setSelectedField] = useState(null);
    const [options, setOptions] = useState([]);
    const [variationName, setVariationName] = useState('');
    const [variationDisplay, setVariationDisplay] = useState(null);
    const [combineNewDrawerOpen, setCombineNewDrawerOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [drawerMode, setDrawerMode] = useState('new');
    const [variant_detils, setVariant_detils] = useState({
        name: "",
        type: ""
    });
    const [variantList, setVariantList] = useState([])
    const [selectedVariant, setSelectedVariant] = useState(null)
    const [drawerVisible, setDrawerVisible] = useState(false);

    useEffect(() => {
        if (selectedData && selectedData.length > 0) {
            const mappedData = selectedData.map((item) => ({
                key: item.key,
                name: item.sapName,
                sku: item.sapSku,
                store: item.store,
                // image: item.image,
                description: '',
                store_id: item.store_id,
                msrp: item.sapMsrp.replace(item.currency_symbol, ""),
                sale_price: item.sapPrice.replace(item.currency_symbol, ""),
                inventory_available: item.reservedStock,
                currency_symbol: item.currency_symbol
            }));

            setTableData(mappedData);
            fetchVariantList()
        }
    }, [selectedData]);

    const fetchVariantList = async () => {
        let variant_data = await apiService.apidata(selectedData[0].store_id)



        if (variant_data && variant_data.length > 0) {
            const mappedDataVar = await variant_data.map(item => ({
                ...item,
                value: item.key,
                label: item.bc_name,
                variant_options: item.variant_options || []
            }))
            setVariantList(mappedDataVar)
        }
    }


    const openDrawerCombineNew = () => setCombineNewDrawerOpen(true);
    const closeDrawer = () => setCombineNewDrawerOpen(false);
    const openDrawerCombineExist = () => setDrawerVisible(true);
    const closeDrawerExisting = () => setDrawerVisible(false);

    //   const [applyToAll, setApplyToAll] = useState(false);
    //   const [descriptionValue, setDescriptionValue] = useState('');
    useEffect(() => {

        // Simulating API call
        const fetchData = async () => {
            const data = [
                { value: 'rectangles', label: 'RectangleList' },
                // { value: 'Swatch', label: 'Swatch' },
                // { value: 'Radio Buttons', label: 'RadioButtons' },
                { value: 'dropdown', label: 'Dropdown' },
            ];
            setOptions(data);
        };

        fetchData();
    }, []);


    const handleTextChange = (val, index) => {
        const newData = [...tableData];
        newData[index].description = val;
        setTableData(newData);
    };

    const handleAddToExistingProductClick = () => {
        setDrawerMode('existing');
        setSelectedField('variation');
    };

    const handleCreateNewProductClick = () => {
        setDrawerMode('new');
        setSelectedField('variation'); // Set selectedField to show "Variation Value"
        const newData = [...tableData];
        setTableData(newData);
    };

    const isSaveEnabled = async () => {
        const hasDescriptions = tableData.every(item => item.description?.trim());
        if (drawerMode === 'existing' && tableData && selectedVariant) {

            return (
                selectedProduct != "" &&
                variationName.trim() !== '' &&
                variationDisplay &&
                hasDescriptions
            );
        }

        return (
            variationName.trim() !== '' &&
            variationDisplay &&
            hasDescriptions
        );
    };

    const canSave = useMemo(() => {
        const hasDescriptions = tableData.every(item => item.description?.trim());
        if (drawerMode === 'existing') {
            return (
                selectedProduct !== "" &&
                variationName.trim() !== '' &&
                variationDisplay &&
                hasDescriptions
            );
        }

        return (
            variationName.trim() !== '' &&
            variationDisplay &&
            hasDescriptions
        );
    }, [drawerMode, selectedProduct, variationName, variationDisplay, tableData]);

    return (
        <>
            <Drawer
                title={
                    selectedField
                        ? drawerMode === 'existing'
                            ? 'Add Variants to an Existing Product'
                            : 'Combine Products as Variants'
                        : 'Combine Products as Variants'
                }
                width={900}
                onClose={onClose}
                open={open}
                closeIcon={
                    selectedField ? (
                        <LeftOutlined
                            onClick={(e) => {
                                e.stopPropagation(); // Prevent Drawer from handling this as a close
                                setSelectedField(null); // Back behavior

                                // Clear variation fields
                                setVariationName('');
                                setVariationDisplay(null);
                                form.resetFields(['VariationName', 'VariationDisplay']);
                            }}
                            style={{ fontSize: '16px', color: '#1890ff' }}
                        />
                    ) : undefined
                }
                extra={
                    selectedField && isSaveEnabled() ? (
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button type="primary" disabled={!canSave} onClick={async e => {
                                if (drawerMode === 'existing') {
                                    // Duplicate check for Variant Values
                                    const existingValues = (selectedProduct?.variant_data || []).map(v => (v.variant_values || '').trim().toLowerCase());
                                    const newDescriptions = tableData.map(item => (item.description || '').trim().toLowerCase());
                                    const duplicate = newDescriptions.find(desc => existingValues.includes(desc));
                                    if (duplicate) {
                                        triggerNotification({
                                            type: 'error',
                                            title: 'Form incomplete!',
                                            message: "Variation Value already exists in the selected product. Please enter a unique value.",
                                        });
                                       
                                        return;
                                    }
                                    const finalmapped = await tableData.map(item => ({
                                        "id": 0,
                                        "store_id": item.store_id,
                                        "bc_product_id": selectedVariant.prod_id,
                                        "variant_sku": item.sku,
                                        "variant_name": variationName,
                                        "variant_type": variationDisplay,
                                        "variant_image": "",
                                        "variant_values": item.description,
                                        "variant_msrp": item.msrp,
                                        "variant_sale_price": item.sale_price,
                                        "variant_default_price": item.msrp,
                                        "weight": "",
                                        "width": "",
                                        "height": "",
                                        "depth": "",
                                        "inventory_available": item.inventory_available,
                                        "inventory_warning_level": 0,
                                        "purchasing_disabled": 0,
                                        "options": JSON.stringify([{ "label": item.description, "option_id": selectedVariant.variant_options[0].option_id, "option_display_name": variationDisplay }]),
                                        "sap_data": null
                                    }))

                                    const updatedMap = new Map();

                                    await selectedVariant.variant_data.forEach(v => {
                                        updatedMap.set(v.variant_sku, v);
                                    });

                                    await finalmapped.forEach(v => {
                                        updatedMap.set(v.variant_sku, v); // This will overwrite if SKU already exists
                                    });

                                    selectedVariant.variant_data = Array.from(updatedMap.values());
                                    openDrawerCombineExist()
                                } else {
                                    openDrawerCombineNew()

                                }
                            }}>
                                Save and Continue

                            </Button>
                        </div>
                    ) : null
                }
            >
                {/* Select Field Part (Commented for now) */}
                {selectedField && (
                    <Form layout="vertical" form={form}>

                        <div style={{ marginBottom: 16 }} className='VariationBoxSelection'>
                            {drawerMode === 'existing' && (
                                <Form.Item
                                    className='SelectProductItem'
                                    label="Select Product"
                                // name={`SelectProduct`}
                                // rules={[{ required: true, message: "Please Select a Product" }]}
                                >
                                    <Select
                                        showSearch
                                        optionFilterProp="label"
                                        style={{ width: "100%" }}
                                        placeholder="Please select the product you want to add the variants to"
                                        onChange={(value) => {
                                            setSelectedProduct(value);

                                            let filteredData = variantList.filter(item => item.key === value)                                            
                                            if (filteredData && filteredData.length > 0) {
                                                
                                                setSelectedProduct(filteredData[0]);
                                                setSelectedVariant(filteredData[0])
                                                setVariationName(filteredData[0].variant_options[0].display_name);
                                                setVariationDisplay(filteredData[0].variant_options[0].type)
                                                form.setFieldsValue({
                                                    VariationName: filteredData[0].variant_options[0].display_name,
                                                    VariationDisplay: filteredData[0].variant_options[0].type
                                                });

                                            }

                                        }}
                                        options={variantList}
                                    />
                                </Form.Item>
                            )}
                            <Row gutter={8}>
                                <Col span={12} className='VariationCol'>
                                    <Form.Item
                                        className='Variation-Item'
                                        label={
                                            <span className="Variation-label">
                                                Variation Name&nbsp;
                                                {/* <QuestionCircleOutlined
                                                    style={{
                                                        color: "rgba(0, 0, 0, 0.45)",
                                                        cursor: "pointer",
                                                    }}
                                                    title="This is the Variation Name."
                                                /> */}
                                            </span>
                                        }
                                        name={`VariationName`}
                                        rules={[{ required: true, message: "Please Enter a Variation Name" }]}
                                    >
                                        <Input
                                            placeholder="Enter a Variation Name"
                                            value={variationName}
                                            onChange={(e) => {
                                                setVariationName(e.target.value);
                                                setVariant_detils({ ...variant_detils, name: e.target.value })

                                            }}
                                            disabled={drawerMode === 'existing'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12} className='VariationCol'>
                                    <Form.Item
                                        className='Variation-Item'
                                        label={
                                            <span>
                                                Variation Display&nbsp;
                                                {/* <QuestionCircleOutlined
                                                    style={{
                                                        color: "rgba(0, 0, 0, 0.45)",
                                                        cursor: "pointer",
                                                    }}
                                                    title="This is the Variation Display."
                                                /> */}
                                            </span>
                                        }
                                        title="This is the Variation Display."
                                        name={`VariationDisplay`}
                                        rules={[{ required: true, message: "Please Enter a Variation Display" }]}
                                    >
                                        <Select
                                            showSearch
                                            placeholder="Please select the variation display"
                                            optionFilterProp="label"
                                            options={options}
                                            value={variationDisplay}
                                            onChange={(value) => {
                                                setVariationDisplay(value)
                                                setVariant_detils({ ...variant_detils, type: value })
                                            }}
                                            disabled={drawerMode === 'existing'}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                )}

                {/* Table */}
                <Table
                    columns={getColumns(
                        selectedField, // Pass selectedField         
                        handleTextChange
                    )}
                    dataSource={tableData}
                    pagination={false}
                    rowKey="key"
                />
                
                {selectedProduct?.variant_data?.length > 0 ? (
                    <div style={{ marginTop: "16px" }} className='VariantOptionsBox'>
                        <h3 style={{ padding: "10px 0", margin: "0 0 10px", }}>
                            Selected Product Variant Data
                        </h3>
                        <Table
                            dataSource={selectedProduct.variant_data.map(option => ({
                                key: option.id,
                                product_name: option.sap_data?.product_name || "NA",
                                variant_sku: option.variant_sku,
                                variant_values: option.variant_values,
                                variationType: option.type,
                                optionValues: (() => {
                                    try {
                                        return JSON.parse(option.options).map(val => val.label).join(", ");
                                    } catch {
                                        return "-";
                                    }
                                })()
                            }))}
                            pagination={false}                            
                            columns={[
                                {
                                    title: "SAP Product Name",
                                    dataIndex: "product_name",
                                    key: "product_name",
                                },
                                {
                                    title: "Variant Sku",
                                    dataIndex: "variant_sku",
                                    key: "variant_sku",
                                },
                                {
                                    title: "Variant Values",
                                    dataIndex: "variant_values",
                                    key: "variant_values",
                                }
                            ]}
                        />
                    </div>
                ) : (
                    <p>No variant options available.</p>
                )}

                {/* Footer Buttons */}
                {!selectedField && (
                    <div className="DrawerButtonFooter" style={{ marginTop: 24 }}>
                        <Button
                            type="primary"
                            className="NewProductBtn"
                            onClick={handleCreateNewProductClick}
                        >
                            Create New Product With Variants
                        </Button>

                        <div className="linebreak">or</div>

                        <Button onClick={handleAddToExistingProductClick}>
                            Add Variants To Existing Product
                        </Button>
                    </div>
                )}
            </Drawer>
            {combineNewDrawerOpen && <DrawerNew
                visible={combineNewDrawerOpen}
                onClose={closeDrawer}
                selected_prod_data={customfielddata}
                setisloader={setisloader}
                selectedData={tableData}
                variant_detils={variant_detils}
                reload={reload}
                globalList={globalList} setGlobalList={setGlobalList}
            // variationDisplay={variationDisplay}
            />}

            {drawerVisible && <VariantDrawer
                visible={drawerVisible}
                onClose={closeDrawerExisting}
                selected_prod_data={selectedVariant}
                setisloader={setisloader}
                onProductCreate={reload}
                globalList={globalList} setGlobalList={setGlobalList}
            />}
        </>
    );
};

export default CombineDrawer;
